import React, { useState, useEffect, useRef } from 'react';

import UseStyles from '../../../useStyles';

import Typography from '@material-ui/core/Typography';
import UserMesa from "../../../reunioesUserTable";

import {
  getLugaresMesa,
  getConvidados,
  atualizarMesa,
  excluirMesa
} from '../../../../../services/reuniao/ReuniaoService';
import { Button } from '@material-ui/core';

const mesaIcon = () => (
  <svg version="1.1" id="Camada_1" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"
    viewBox="0 0 10.3 41.6"  >
    <path fill="#C2C4D1" d="M9.5,0.2H0.8v41.2h2.9V3.4h2.9v38.1h2.9V0.2z" />
  </svg>
);

const ReuniaoMesa = (props) => {

  const {
    validar,
    handleStepper,
    dados,
    updateDados,
    isEditar,
    isVisualizar,
    history
  } = props;

  const [state, setState] = useState(false);


  const validarCampos = () => {
    validar.validado = true;
    handleStepper(3);
  }


  useEffect(() => {
    //validar.validado = true;
    setSize(sizeRef.current.clientHeight);
  }, []);

  const updateCadeira = async (lugar, usuario) => {
    const formData = new FormData();
    formData.append('idReuniao', dados.id);
    formData.append('idConvidado', usuario.usuarioPerfil.id);
    formData.append('lugar', lugar);

    const auxDados = { ...dados };
    const mesaAux = { ...auxDados.mesa };

    await atualizarMesa(formData);
    mesaAux[lugar] = usuario;

    for (let j = 1; j <= 33; ++j) {
      if ((`cadeira` + j) !== lugar && mesaAux[`cadeira${j}`] === mesaAux[lugar]) {
        mesaAux[`cadeira${j}`] = '';
      }
    }
    updateDados({ ...auxDados, mesa: { ...mesaAux } });
    setState((prev) => !prev);
  }

  const removeCadeira = async (usuario, lugar) => {
    await excluirMesa(dados.id, usuario.usuarioPerfil.id);
    const auxDados = { ...dados };
    const mesaAux = { ...auxDados.mesa };
    mesaAux[`cadeira${lugar}`] = '';
    updateDados({ ...auxDados, mesa: { ...mesaAux } });
    setState((prev) => !prev);
  }

  const classes = UseStyles();

  const sizeRef = useRef();
  const [size, setSize] = useState(700);

  const montarLugares = (listaConvidados) => {
    if (listaConvidados.length > 0) {
      getLugaresMesa(dados.id).then((response) => {
        if (response && response.status === 200) {
          response.data.forEach((lugarPreenchido) => {
            const convidadoLugar = listaConvidados.find((convidado) => convidado.usuarioPerfil.id === lugarPreenchido.usuarioPerfil.id);
            if (convidadoLugar) {
              dados.mesa[lugarPreenchido.lugar] = convidadoLugar;
              setState((prev) => !prev);
            }
          });
        }
      });
    }
  }

  const finaliza = () => {
    history.push(`/reuniao/${dados.id}/visualizar`);
  }

  // atualizar as cadeiras da mesa, recarregar informações
  useEffect(() => {

  }, [state])

  useEffect(() => {
    montarLugares(dados.usuariosConvidados);
  }, [dados.usuariosConvidados])

  useEffect(() => {
    if (dados.usuariosConvidados.length < 1) {
      getConvidados(dados.id).then((response) => {
        if (response && response.status === 200) {
          const { data } = response;
          updateDados({ ...dados, usuariosConvidados: data });
        }
      });
    }
  }, [])

  const proximaAba = (skip = false) => {
    if (!skip) {
      handleStepper(5);
    }else {
      history.push(`/reuniao/${dados.id}/visualizar`);
    }
  }

  return (
    <>
      <div >
        <div style={{marginTop: 150,  padding: '0 24px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
            <Typography className={classes.tituloAba}>Disposição da mesa</Typography>
            {/* <Typography>Ultima atualização em ---</Typography> */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8}}>
              {!isVisualizar && <Button onClick={finaliza} variant="contained">Finalizar</Button>}
              {isEditar && <Button onClick={() => proximaAba()} variant="contained">Próximo</Button>}
            </div>
          </div>
          <div id="mesa">
            <div id="cabecalho" style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ margin: '0 15px' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='1' editHandle={updateCadeira} handleRemove={removeCadeira} user={dados.mesa.cadeira1} /></div>
              <div style={{ margin: '0 15px' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='2' editHandle={updateCadeira} handleRemove={removeCadeira} user={dados.mesa.cadeira2} /></div>
              <div style={{ margin: '0 15px' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='3' editHandle={updateCadeira} handleRemove={removeCadeira} user={dados.mesa.cadeira3} /></div>
            </div>
            <div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'stretch' }}>
                <div ref={sizeRef} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='4' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira4} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='5' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira5} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='6' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira6} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='7' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira7} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='8' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira8} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='9' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira9} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='10' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira10} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='11' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira11} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='12' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira12} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='13' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira13} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='14' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira14} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='15' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira15} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='16' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira16} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='17' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira17} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='18' editHandle={updateCadeira} handleRemove={removeCadeira} type='right' user={dados.mesa.cadeira18} /></div>
                </div>
                <div style={{ padding: '20px 0', minWidth: 100 }}>
                  {/* <img src={Mesa} /> */}
                  {mesaIcon()}
                  {/* <div style={{width:'100%', height:700, borderRadius: 16, backgroundColor:'#c2c4d1', position:'absolute', top:20, left:0, bottom:0, right:0}}></div>
                  <div style={{borderRadius: 12, backgroundColor:'#fafafa', position:'absolute', top:170, left:'30%', width:'40%', height:560}}></div> */}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='19' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira19} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='20' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira20} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='21' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira21} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='22' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira22} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='23' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira23} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='24' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira24} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='25' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira25} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='26' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira26} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='27' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira27} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='28' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira28} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='29' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira29} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='30' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira30} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='31' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira31} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='32' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira32} /></div>
                  <div style={{ margin: '20px 0 30px 0' }}><UserMesa isVisualizar={isVisualizar} opcoes={dados.usuariosConvidados} lugar='33' editHandle={updateCadeira} handleRemove={removeCadeira} type='left' user={dados.mesa.cadeira33} /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReuniaoMesa;
